import { graphql } from "react-relay";

export const calendarStatusFragments = {
  person: graphql`
    fragment CalendarStatus_person on Person {
      profile {
        givenName
      }
    }
  `,
  calendarStatus: graphql`
    fragment CalendarStatus_calendarStatus on CalendarStatus {
      status
    }
  `,
  profileTimeZone: graphql`
    fragment CalendarStatus_profileTimeZone on ProfileTimeZone {
      timeZone
      userId
      calendarId
    }
  `,
};
